import React, { useState } from 'react';
import SevenDayGuaranteeModal from '|/components/seven-day-guarantee-modal';
import { useSlate } from '|/context';
import Icon from './icon.svg';
import styles from './seven-day-banner.module.css';

const textPrefix =
  'If you don’t love your new ride, you can simply return or exchange it as part of your ';
const linkText = '7‑Day Money Back Guarantee';
const textSuffix = '.';

export interface SevenDayBannerProps {
  analyticsId?: string;
  compact?: boolean;
}

export const SevenDayBanner = ({
  analyticsId = 'pp_complete_purchase_pao_seven_day_link',
  compact = false
}: SevenDayBannerProps = {}) => {
  const { isSlateVehicle } = useSlate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (isSlateVehicle) {
    return null;
  }

  const iconSize = compact ? '32px' : '48px';
  const containerClassName = compact
    ? `${styles.container} ${styles.containerCompact}`
    : styles.container;

  return (
    <>
      <div className={containerClassName}>
        <Icon className={styles.icon} width={iconSize} height={iconSize} />

        <div className={styles.text}>
          {textPrefix}

          <span
            className={styles.link}
            role="button"
            tabIndex={0}
            aria-haspopup="dialog"
            onClick={() => {
              setIsModalOpen(true);
            }}
            onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsModalOpen(true);
              }
            }}
            data-analytics-id={analyticsId}
          >
            {linkText}
          </span>

          {textSuffix}
        </div>
      </div>

      <SevenDayGuaranteeModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      />
    </>
  );
};
